'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var escapeStringRegexp = require('escape-string-regexp');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var escapeStringRegexp__default = /*#__PURE__*/_interopDefaultLegacy(escapeStringRegexp);

const IN_STOCK = 'in-stock';
const UNAVAILABLE_IN_THIS_SET = 'not available in this set';
const UNAVAILABLE_IN_ANY_SET = 'not available in any set';
function maxBy(list, getScore) {
  let maxScore = 0;
  let max = list[0];
  list.forEach(item => {
    const score = getScore(item);
    if (score > maxScore) {
      maxScore = score;
      max = item;
    }
  });
  return max;
}

/**
 * Sparsem class cloned from `narvar/shopify-zero-retailer`. It allows you to
 * search availability status of a specify exchange option.
 */
class Sparsem {
  constructor() {
    _defineProperty__default["default"](this, "SEP", '\t');
    _defineProperty__default["default"](this, "BLANK", '__BLANK__');
    _defineProperty__default["default"](this, "arr", []);
    _defineProperty__default["default"](this, "inp", []);
    _defineProperty__default["default"](this, "opts", []);
  }
  get num() {
    return this.opts.length;
  }
  setArr(availableItems, optionsConfig) {
    this.inp = availableItems;
    this.opts = optionsConfig;
    this.arr = availableItems.map(x => x.map(y => y ?? this.BLANK).join(this.SEP));
  }
  search() {
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    const str = options.map((option, i) => {
      if (i >= this.num) return;
      if (option) return escapeStringRegexp__default["default"](option);
      return '.{1,}';
    }).filter(Boolean).join(this.SEP);
    const out = this.arr.filter(x => x.match(new RegExp(`^${str}$`))).map(x => x.split(this.SEP));
    const missingIdx = options.indexOf(null);
    if (!this.opts[missingIdx]) return {};
    const result = this.opts[missingIdx].reduce((ret, val) => {
      ret[val ?? ''] = out.some(x => x[missingIdx] === val) ? IN_STOCK : this.inp.some(x => x[missingIdx] === val) ? UNAVAILABLE_IN_THIS_SET : UNAVAILABLE_IN_ANY_SET;
      return ret;
    }, {});
    return result;
  }
  select(options) {
    const result = maxBy(this.inp, availableItem => availableItem.reduce((score, itemOption, index) => {
      const match = options[index] === itemOption;
      return match ? score + 1 : score;
    }, 0));
    return result;
  }
}

exports.IN_STOCK = IN_STOCK;
exports.UNAVAILABLE_IN_ANY_SET = UNAVAILABLE_IN_ANY_SET;
exports.UNAVAILABLE_IN_THIS_SET = UNAVAILABLE_IN_THIS_SET;
exports["default"] = Sparsem;
